import { memo } from "react";
import { Box } from "@mui/material";

import { useAppContext } from "../../../2_ksbHub/context/appContext";
import { useBszFinderContext } from "../context/bszContext";

import AppContentWrapper from "../../../2_ksbHub/components/AppContentWrapper";

import BSZMain from "./BSZMain";
import BSZDialogs from "./dialogComponents/BSZDialogs";
import BSZAlerts from "./alerts/BSZAlerts";

import useBszActions from "../hooks/useBszActions";
import useBszDialogs from "../hooks/useBszDialogs";

/**
 * =========================================================
 * ✅ BSZ CONTENT (stable + aligned)
 * =========================================================
 */
function BSZContent({ viewMode }) {
  const { isMobile } = useAppContext();

  const { rooms: rawRooms } = useBszFinderContext();

  /**
   * ✅ CRITICAL FIX: NEVER allow undefined
   */
  const rooms = Array.isArray(rawRooms) ? rawRooms : [];

  const actions = useBszActions();
  const dialogs = useBszDialogs();

  /**
   * =========================================================
   * ✅ RENDER
   * =========================================================
   */
  return (
    <Box
      sx={{
        flex: 1,
        mt: isMobile ? 1 : 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* ✅ CONTENT */}
      <AppContentWrapper padding={false} gap={1.2} scrollable={false}>
        <BSZMain
          viewMode={viewMode}
          rooms={rooms} // ✅ SAFE NOW
          dialogs={dialogs}
          actions={actions}
        />
      </AppContentWrapper>

      {/* ✅ DIALOGS */}
      <BSZDialogs dialogs={dialogs} actions={actions} />

      {/* ✅ ALERTS */}
      <BSZAlerts actions={actions} />
    </Box>
  );
}

export default memo(BSZContent);
